import React, { Component } from 'react';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import Select from 'react-select';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

class NlpDemo extends Component {
    constructor() {
        super();
        this.state = {
            successResp: true,
            inputVal: '',
            outputJson: '',
            languageVal: { value: 'ENGLISH', label: 'English' }
        }
        this.languageOptions = [{
            value: 'ENGLISH', label: 'English'
        },
        {
            value: 'HINDI', label: 'Hindi'
        },
        {
            value: 'KANNADA', label: 'Kannada'
        },
        {
            value: 'TAMIL', label: 'Tamil'
        },
        {
            value: 'MALAYALAM', label: 'Malayalam'
        },
        {
            value: 'BANGLA', label: 'Bangla'
        },
        {
            value: 'TELUGU', label: 'Telugu'
        },
        {
            value: 'GUJARATI', label: 'Gujarati'
        },
        {
            value: 'MARATHI', label: 'Marathi'
        }];
    }

    notifyFailedToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    handleChangeInput = (e) => {
        this.setState({ inputVal: e.target.value });
    }

    resetData = () => {
        document.getElementById("inputVal").value = "";
        document.getElementById("outputVal").value = "";
    }

    handleLangChange = (e) => {
        this.state.languageVal = { value: e.value, label: e.label }
        this.setState(this.state);
    }

    notifyFailedToLoadLanguages() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    fetchLanguagesForNlp = () => {
        var thisController = this;
        $.ajax({
            url: "/api/agent-languages-nlp",
            async: false,
            method: 'GET',
            data: { projectId: localStorage.getItem('currentProjectId') },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.successResp = true;
                    thisController.setState(thisController.state);
                    if (res.result.length !== 0) {
                        var loadlanguage = res.result;
                        for (var i = 0; i < loadlanguage.length; i++) {
                            thisController.languageOptions.push({ 'value': loadlanguage[i]['code'], 'label': loadlanguage[i]['name'] })
                        }
                        thisController.state.languageVal = { 'value': loadlanguage[0]['code'], 'label': loadlanguage[0]['name'] }
                        thisController.setState(thisController.state);
                    } else {
                        thisController.notifyNoLangSelected();
                    }
                } else {
                    thisController.notifyFailedToLoadLanguages(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyNoLangSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
            position: "top-center"
        });
    }

    parseAction = () => {
        var languageController = this;
        if (languageController.state.languageVal.value == "") {
            languageController.notifyNoLangSelected();
        } else {
            var language = this.state.languageVal.value;
            var d = new Date();
            var currentTime = d.getTime();
            let apiUsageRecord = {
                projectId: localStorage.getItem("currentProjectId"),
                userId: JSON.parse(localStorage.getItem("user_details")).userId,
                inputValue: languageController.state.inputVal,
                language: language,
                // apiType : "NLP_API",
                usageTime: currentTime
            }
            $.ajax({
                url: "/api/parse-sentence",
                async: false,
                method: 'GET',
                data: apiUsageRecord,
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                success: function (res) {
                    if (res.success === true) {
                        languageController.state.outputJson = res.result;
                        languageController.setState(languageController.state);
                    } else {
                        languageController.notifyFailedToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }
    }

    componentDidMount() {
        let thisController = this;

        document.addEventListener("projectChanged", function (event) {

            if (thisController.isNullOrEmpty(document.getElementById("inputVal"))) {
                document.getElementById("inputVal").value = "";
            }
            if (thisController.isNullOrEmpty(document.getElementById("outputVal"))) {
                document.getElementById("outputVal").value = "";
            }

        })
    }

    isNullOrEmpty(fieldVal) {
        if (fieldVal === "") {
            return false;
        } else if (fieldVal === null) {
            return false;
        } else if (fieldVal === undefined) {
            return false;
        } else {
            return true;
        }
    }

    render() {
        const yourJSON = this.state.outputJson.result;

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none', height: "450px" }}>
                    <div style={{ background: "#F9F9FB" }}>
                        {/* for toaster */}
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        {/* for reactTable */}
                        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                        {/*for dialog component */}
                        <link href="assets/css/ej2-base.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                        <link href="assets/css/screenResolution.css" rel="stylesheet" />

                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />

                        {/* Select2 */}
                        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/toggleButton.css" />
                        <link rel="stylesheet" href="./assets/css/react-table-height.css" />

                        {/* pretty print json css*/}
                        <link rel="stylesheet" href="./assets/css/prettyJson.css" />

                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <h1 className="m-0 page-title"></h1>
                                        <h6 className="taglineTxt"></h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <Select
                                            id="language"
                                            style={{ width: '12px' }}
                                            value={this.state.languageVal}
                                            onChange={this.handleLangChange}
                                            options={this.languageOptions} />

                                    </div>
                                    <div className="col-sm-4" style={{ marginBottom: '70px' }}>
                                    </div>
                                </div>
                            </div>

                            <div className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label>Input</label>
                                            <div className="card" style={{ borderRadius: '10px' }}>
                                                <textArea id="inputVal" value={this.state.inputVal} onChange={this.handleChangeInput} style={{ height: '200px', border: "none" }} />
                                            </div>
                                        </div>
                                        <div className="col-md-3" style={{ textAlign: 'center', marginTop: '36px', display: 'grid' }}>
                                            <button className="btn2 table-action-button "
                                                title="Parse your input"
                                                onClick={this.parseAction}
                                                style={{
                                                    width: '80px', height: '36px', marginLeft: 'auto', marginRight: 'auto',
                                                    marginTop: 'auto'
                                                }}>Parse!</button>
                                            <button className="btn2 table-action-button "
                                                onClick={this.resetData}
                                                title="Reset your input"
                                                style={{ width: '40px', height: '36px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '54px' }}>
                                                <img src="assets/images/reset.png" />
                                            </button>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Output</label>

                                            <div className="card">
                                                <JSONPretty data={yourJSON}
                                                    id="outputVal"
                                                    style={{ height: '200px', border: 'none' }}></JSONPretty>

                                            </div>
                                            <ToastContainer className="Toast-at-center" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default NlpDemo;



// WEBPACK FOOTER //
// ./src/nlpUi/NlpDemo.js